<template>
  <div>
    <Top></Top>
    <!-- topBox start -->
    <div class="topBox"></div>
    <!-- topBox end  -->
    <!-- start -->
    <div class="topContent">
      <div class="flex">
        <div class="flexBox" :class="allInOneCur == 0 ? 'active' : 'flexBox'" @click="clickTab(0)">
          <img :src="yingJianImg1">
          <div class="hardwareText">V5</div>
        </div>
        <div class="flexBox" :class="allInOneCur == 1 ? 'active' : 'flexBox'" @click="clickTab(1)">
          <img :src="yingJianImg1">
          <div class="hardwareText">V8</div>
        </div>
        <div class="flexBox" :class="allInOneCur == 2 ? 'active' : 'flexBox'" @click="clickTab(2)">
          <img :src="yingJianImg2">
          <div class="hardwareText">商业电视</div>
        </div>
        <div class="flexBox" :class="allInOneCur == 3 ? 'active' : 'flexBox'" @click="clickTab(3)">
          <img :src="yingJianImg3">
          <div class="hardwareText">一体机</div>
        </div>
        <div class="flexBox" :class="allInOneCur == 4 ? 'active' : 'flexBox'" @click="clickTab(4)">
          <img :src="yingJianImg4">
          <div class="hardwareText">综合传感器</div>
        </div>
        <div class="flexBox" :class="allInOneCur == 5 ? 'active' : 'flexBox'" @click="clickTab(5)">
          <img :src="yingJianImg5">
          <div class="hardwareText">4mm拼接屏</div>
        </div>
        <div class="flexBox" :class="allInOneCur == 6 ? 'active' : 'flexBox'" @click="clickTab(6)">
          <img :src="yingJianImg2">
          <div class="hardwareText">桌面屏</div>
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- 面包屑 start -->
    <!-- <Bread :breadChild = toBreadChild></Bread> -->
    <!-- 面包屑 end -->
    <!-- middle content start -->
    <VFive v-show="allInOneCur === 0"></VFive>
    <VEight v-show="allInOneCur === 1"></VEight>
    <BussinessTv v-show="allInOneCur === 2"></BussinessTv>
    <AllInOne v-show="allInOneCur === 3"></AllInOne>
    <Synthesize v-show="allInOneCur === 4"></Synthesize>
    <Sensor v-show="allInOneCur === 5"></Sensor>
    <DeskTopScreen v-show="allInOneCur === 6"></DeskTopScreen>


    <!-- middle content end -->
    <Footer></Footer>
  </div>
</template>
<script>
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
import hardware1 from "@/assets/images/hardware1.png";
import hardware2 from "@/assets/images/hardware2.png";

import canshubiao from "@/assets/images/canshubiao.png";

import hardwareTop1 from "@/assets/images/hardwareTop1.png";
import hardwareTop4 from "@/assets/images/hardwareTop4.png";
import hardwareTop6 from "@/assets/images/hardwareTop6.png";

import yingJianImg1 from "@/assets/images/yingJianImg1.png";
import yingJianImg2 from "@/assets/images/yingJianImg2.png";
import yingJianImg3 from "@/assets/images/yingJianImg3.png";
import yingJianImg4 from "@/assets/images/yingJianImg4.png";
import yingJianImg5 from "@/assets/images/yingJianImg5.png";
import yingJianImg6 from "@/assets/images/yingJianImg6.png";
console.log(yingJianImg6, 'yingJianImg6');

import Bread from "@/components/bread.vue";

import Sensor from "@/view/hardware/sensor";
import AllInOne from "@/view/hardware/allInOne";
import Synthesize from "@/view/hardware/synthesize";
import VFive from "@/view/hardware/vFive";
import VEight from "@/view/hardware/vEight"
import BussinessTv from "@/view/hardware/bussinessTv"
import DeskTopScreen from "@/view/hardware/DeskTopScreen"


export default {
  name: "Hardware",
  components: {
    Top,
    Footer,
    Bread,
    Sensor,
    Synthesize,
    AllInOne,
    VFive,
    VEight,
    BussinessTv: BussinessTv,
    DeskTopScreen
  },
  data() {
    return {
      toBreadChild: ["硬件"],
      allInOneCur: 0,
      hardware1: hardware1,
      hardware2: hardware2,
      canshubiao: canshubiao,
      hardwareTop1: hardwareTop1,
      hardwareTop4: hardwareTop4,
      hardwareTop6: hardwareTop6,
      yingJianImg1: yingJianImg1,
      yingJianImg2: yingJianImg2,
      yingJianImg3: yingJianImg3,
      yingJianImg4: yingJianImg4,
      yingJianImg5: yingJianImg5,
      yingJianImg6: yingJianImg6
    }

  },
  methods: {
    clickTab(index) {
      this.allInOneCur = index
    }
  }
};
</script>
<style scoped>
.topBox {
  width: 100%;
  height: 134px;
  background: rgba(0, 0, 0, 1);
}

.hardwareText {
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  position: absolute;
  bottom: 18px;
  width: 110px;
  left: calc(50% - 55px);
  text-align: center;
}

.topContent {
  width: 100%;
  min-width: 997px;
  background: rgba(240, 240, 240, 1);
}

.flex {
  display: flex;
  width: 75%;
  margin: auto;
  justify-content: space-around;
  text-align: center;
}

.flexBox {
  flex-grow: 1;
  position: relative;
  text-align: center;
  transition: 0.5s;
  cursor: pointer;
}

.flexBox img {
  width: 100%;
  max-width: 136px;
}

.flexBox:hover {
  /* background: #fff; */
}



.middleContent {
  text-align: center;
  margin-top: 111px;
}

.middleContentText {
  font-size: 6rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  margin-top: 28px;
}

.chuanGanQi {
  margin-top: 89px;
}

.marginTop58 {
  margin-top: 58px;
}

.imgSmall {
  width: 60%;
  max-width: 701px;
}

.imgBig {
  width: 80%;
}

.active {
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/Hardware.vue